module.exports = __webpack_public_path__ + "static/media/BBC_WorldNews_Tile.dd762618.svg";